import gql from 'graphql-tag';

export default gql`
    mutation SendEmail($input: SendEmailInput) {
        sendEmail(input: $input) {
            errors
        }
    }
`;
